import React, { Component } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
export default class Tabel extends Component {
  render() {
    const { sensor, gastverbruik } = this.props;
    
    // Determine if we're dealing with hourly data based on data density
    // Ensure consistent timezone handling when calculating time differences
    const isHourlyData = sensor?.data && sensor.data.length > 2 && 
      moment(sensor.data[1].datum).local().diff(moment(sensor.data[0].datum).local(), 'hours') <= 1;

    // Apply the same data processing logic as the graph component
    const tableData = sensor?.data ? sensor.data.map((item, index) => {
      let displayValue;
      
      if (isHourlyData && index > 0) {
        // For hourly data, calculate consumption as difference between consecutive readings
        // Use same logic as graph: previous - current
        const previousValue = sensor.data[index - 1].value;
        displayValue = parseFloat((previousValue - item.value).toFixed(2));
        // Prevent negative values due to meter resets
        if (displayValue < 0) displayValue = 0;
      } else if (isHourlyData && index === 0) {
        // First hourly entry: we can't calculate difference, skip it
        return null;
      } else {
        // For daily/monthly data, use the raw value
        displayValue = parseFloat(item.value.toFixed(2));
      }
      
      return {
        ...item,
        displayValue: displayValue
      };
    }).filter(item => item !== null) : [];

    function dateFormatter(cell, row) {
      // Ensure we use local timezone and Dutch formatting
      const taal = localStorage.getItem("taal")?.toLowerCase() || "nl";
      moment.locale(taal);
      
      return isHourlyData ? 
        moment(cell).local().format("DD-MM-YYYY HH:mm") : 
        moment(cell).local().format("DD-MM-YYYY");
    }

    const columns = [
      {
        dataField: "datum",
        text: isHourlyData ? "Datum & Tijd" : "Datum",
        formatter: dateFormatter,
      },
      {
        dataField: isHourlyData ? "displayValue" : "value",
        text: isHourlyData ? "Verbruik per uur (kWh)" : "Verbruik per dag (kWh)",
        formatter: (cellContent, row) => {
          if (cellContent !== null && cellContent !== undefined) {
            return cellContent.toFixed(2);
          } else {
            return "0.00";
          }
        },
      },
    ];
    return <BootstrapTable wrapperClasses="table-responsive-md" keyField="datum" data={tableData} columns={columns} pagination={paginationFactory()} />;
  }
}


